import type React from "react";
import CreateNameForm from "../common/CreateNameForm";
import { TestId } from "../../constants/testIds";

interface CreateCustomerFormProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: { name: string }) => Promise<void>;
  error: string | null;
  initialData?: { name: string };
  isEditing?: boolean;
}

const CreateCustomerForm: React.FC<CreateCustomerFormProps> = (props) => {
  return (
    <CreateNameForm
      {...props}
      entityName="Customer"
      labelTranslationKey="Customer Name"
      placeholder="Customer name"
      addTextTranslationKey="Add Customer"
      editTextTranslationKey="Edit Customer"
      formTestId={TestId.CUSTOMER.FORM}
    />
  );
};

export default CreateCustomerForm;
